export default "__VITE_ASSET__94c79a5d__"